import useStoreExport from 'hooks/useStoreExport'
import { useSelector } from 'react-redux'

import { getModeledSaves } from "selectors"

const useSaveGame = () => {
  const payload = useSelector(getModeledSaves)
  const { onExport } = useStoreExport()
  const onDownload = () => onExport(payload)

  return {
    onDownload
  }
}

export default useSaveGame
